import React from "react";
import Add from "../../icons/Add";

const QuoteHeader = () => {
  return (
    <div
      className="p-5 rounded-[10px] bg-[#fff]"
      style={{ border: "1px solid rgba(5, 63, 146, 0.24)" }}
    >
      {/* Parent Flex  */}
      <div className="flex flex-wrap items-center justify-between space-y-2">
        {/* Filter Button And Search */}
        <div className="flex items-center space-x-2">
          <div
            style={{
              background: "rgba(218, 28, 0, 0.03)",
              border: "1px solid #DA1C00",
            }}
            className="flex rounded-[5px] items-center space-x-4 py-3 px-6 text-[#DA1C00]"
          >
            <p style={{ color: "rgba(24, 24, 35, 0.53)" }}>All Users</p>
            <select className="outline-none" name="" id=""></select>
          </div>
        </div>

        {/* Add Admin Button */}
        <div className="active:opacity-70 flex cursor-pointer space-x-2 py-3 px-6 bg-[#DA1C00] rounded-[5px]">
          {/* Add icon */}
          <div className="h-[24px] w-[24px] bg-[#fff] rounded-full flex justify-center items-center">
            <Add />
          </div>
          <p className="text-[#fff]">Create Quote</p>
        </div>
      </div>
    </div>
  );
};

export default QuoteHeader;
